"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".ms-Layer--fixed{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.ms-Layer-content{visibility:visible}" }]);
/* tslint:enable */ 

//# sourceMappingURL=Layer.scss.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Layer/Layer.scss.js
// module id = 48
// module chunks = 0